// Carry Roll DemoDataControls — clear demo data + toggle the header "Load Demo" link.
// Stage 10 standard settings controls.

import { Trash2 } from 'lucide-react';
import { useStore } from '../../store';
import { useUI } from '../../store/uiStore';

export function DemoDataControls() {
  const showLoadDemo = useStore((s) => s.showLoadDemo);
  const setShowLoadDemo = useStore((s) => s.setShowLoadDemo);
  const clearDemoData = useStore((s) => s.clearDemoData);
  const openDemoPicker = useUI((s) => s.openDemoPicker);

  return (
    <div data-testid="demo-data-controls" className="grid gap-3">
      <div className="flex items-center justify-between">
        <label htmlFor="show-load-demo" className="field-label">
          Show Load Demo option
        </label>
        <button
          id="show-load-demo"
          type="button"
          role="switch"
          aria-checked={showLoadDemo}
          className="btn"
          aria-label={showLoadDemo ? 'Hide Load Demo option' : 'Show Load Demo option'}
          aria-pressed={showLoadDemo}
          onClick={() => setShowLoadDemo(!showLoadDemo)}
          data-testid="show-load-demo-toggle"
          style={{
            borderColor: showLoadDemo ? 'var(--color-accent)' : 'var(--color-border)',
            color: showLoadDemo ? 'var(--color-accent)' : 'var(--color-text-muted)',
            minWidth: '52px',
          }}
        >
          {showLoadDemo ? 'On' : 'Off'}
        </button>
      </div>
      <div className="flex gap-2 flex-wrap">
        <button
          type="button"
          className="btn btn-primary"
          onClick={openDemoPicker}
          data-testid="open-demo-picker"
        >
          Load demo
        </button>
        <button
          type="button"
          className="btn"
          onClick={clearDemoData}
          data-testid="clear-demo-data"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-2)' }}
        >
          <Trash2 size={16} aria-hidden="true" /> Clear demo data
        </button>
      </div>
    </div>
  );
}
